import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface NotificationComponentStyles {
  alert: AppSx;
  alertTitle: (hasContent: boolean) => AppSx;
  reason: AppSx;
}

export function buildNotificationComponentStyles(_theme: Theme): NotificationComponentStyles {
  return {
    alert: {
      width: "100%",
      minWidth: 320,
      maxWidth: 420,
      "& .MuiAlertTitle-root, & .MuiTypography-root": { color: "inherit" },
    },
    alertTitle: (hasContent) => ({ mb: hasContent ? 0.5 : 0, color: "inherit" }),
    reason: { mt: 0.75, opacity: 0.9, color: "inherit" },
  };
}
